var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-card-text',[_c('MoleculeTable',{attrs:{"search":_vm.search}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }